<style>
.label {
    color: #808CA3;
    font-weight: normal;
    font-size: 70%;
    text-transform: uppercase;
}


</style>

<template>

    <div class="modal fade course-schedules-details" ref="courseScheduleCreateModal" tabindex="-1" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">
                        Add to Schedule
                    </h5>
                    <button type="button" class="btn-close" @click="hide()" aria-label="Close"></button>
                </div>

                <div class="modal-body" v-if="courseScheduleForm">
                    <div class="alert alert-danger" v-if="errors.length">
                        <ul>
                            <li v-for="error in errors">{{ error }}</li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row mb-3">
                                <div class="col-md-4 label">Path</div>
                                <div class="col-md-8">
                                    <select class="form-select" v-model="courseScheduleForm.reset_level_id"
                                            title="paths">
                                        <option v-for="path in library.paths" :value="path.id">{{
                                                path.name
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 label">Status</div>
                                <div class="col-md-8">
                                    <select v-model="courseScheduleForm.is_active" class="form-select">
                                        <option value="0">not active</option>
                                        <option value="1">active</option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 label app-required">Date</div>
                                <div class="col-md-8">
                                    <input type="date" v-model="courseScheduleForm.date" class="form-control">
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 label app-required">Time</div>
                                <div class="col-md-1 label">From</div>
                                <div class="col-md-3">
                                    <input type="time" v-model="courseScheduleForm.time_from" class="form-control"
                                           @change="updateTime('from')">
                                </div>
                                <div class="col-md-1 label">Till</div>
                                <div class="col-md-3">
                                    <input type="time" v-model="courseScheduleForm.time_till" class="form-control"
                                           @change="updateTime('till')">
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 label app-required">Class</div>
                                <div class="col-md-8">
                                    <select class="form-select" v-model="courseScheduleForm.course_id" title="courses"
                                            @change="updateTrainer()">
                                        <option v-for="course in library.courses" :value="course.id">{{
                                                course.name
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 label app-required">Trainer</div>
                                <div class="col-md-8">
                                    <select class="form-select" v-model="courseScheduleForm.trainer_id"
                                            title="trainers">
                                        <optgroup label="prefered">
                                            <option v-for="trainer in getPreselectedTrainers()" :value="trainer.id">*   {{
                                                    trainer.name
                                                }}
                                            </option>
                                        </optgroup>
                                        <optgroup label="others">
                                            <option v-for="trainer in getOthersTrainers()" :value="trainer.id">{{
                                                    trainer.name
                                                }}
                                            </option>
                                        </optgroup>
                                    </select>

                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 label">Level</div>
                                <div class="col-md-8">
                                    <select class="form-select" v-model="courseScheduleForm.course_level_id"
                                            title="levels">
                                        <option v-for="level in library.levels" :value="level.id">{{
                                                level.name
                                            }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 label">Capacity</div>
                                <div class="col-md-8">
                                    <input type="number" v-model="courseScheduleForm.capacity" class="form-control">
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 label app-required">Location</div>
                                <div class="col-md-8">
                                    <select class="form-select" v-model="courseScheduleForm.location_id"
                                            title="locations">
                                        <option v-for="location in library.locations" :value="location.id">
                                            {{ location.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="row mb-3">
                                <div class="col-md-4 label">Location comment</div>
                                <div class="col-md-8">
                                    <input type="text" v-model="courseScheduleForm.location_comment"
                                           class="form-control" maxlength="150">
                                </div>
                            </div>
                        </div>

                    </div>

                    <p>
                        <span class="app-required"></span> This field will be displayed in the RESET Guest App.
                    </p>
                    <p>
                        <span class="text-danger small">Changing current schedule does not update existing template.</span>
                    </p>


                    <div class="modal-footer">

                        <button type="button" class="btn btn-secondary" @click="hide()">Cancel</button>
                        <button type="button" class="btn btn-primary" @click="save()" :disabled="loading">Create
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

const mixinDayJs = require('../../helpers/vue_mixins').mixinDayJs;
const mixinErrorHandler = require('../../helpers/vue_mixins').mixinErrorHandler;
import {Modal} from 'bootstrap'

export default {
    mixins: [mixinDayJs, mixinErrorHandler],
    props: {
        filters: Object,
        library: Object,
        date: Object,
    },
    data() {
        return {
            errors: [],
            modal: null,
            viewType: 'show',
            courseScheduleForm: null,
            loading: false
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.loading = false;
            this.toFormData();
            if (!this.modal) {
                this.modal = new Modal(this.$refs.courseScheduleCreateModal);
            }
            if (!this.modal.visible) {
                this.modal.show();
            }
        },

        toFormData() {
            let form = {};
            form.date = this.dateFormat(this.date, 'YYYY-MM-DD');
            form.time_from = this.dateFormat(this.date, 'HH:mm');
            form.time_till = this.dateFormat(this.date.clone().add(1, 'hour'), 'HH:mm');
            form.is_active = 1;
            if (this.filters.course) {
                form.course_id = this.filters.course.id;
            } else {
                form.course_id = null;
            }
            if (this.filters.trainer) {
                form.trainer_id = this.filters.trainer.id;
            } else {
                form.trainer_id = null;
            }
            if (this.filters.level) {
                form.course_level_id = this.filters.level.id;
            } else {
                form.course_level_id = null;
            }
            if (this.filters.location) {
                form.location_id = this.filters.location.id;
            } else {
                form.location_id = null;
            }
            if (this.filters.path) {
                form.reset_level_id = this.filters.path.id;
            } else {
                form.reset_level_id = null;
            }
            form.location_comment = '';
            form.capacity = 10;
            this.courseScheduleForm = form;
        },

        updateTrainer() {
            const course = _(this.library.courses).find({id: this.courseScheduleForm.course_id});
            if (course.trainer_ids && course.trainer_ids.length > 0 && !this.courseScheduleForm.trainer_id) {
                this.courseScheduleForm.trainer_id = course.trainer_ids[0];
            }
            if (course.course_level_id && !this.courseScheduleForm.course_level_id) {
                this.courseScheduleForm.course_level_id = course.course_level_id;
            }
        },

        getPreselectedTrainers() {
            const course = _(this.library.courses).find({id: this.courseScheduleForm.course_id});
            if (course && course.trainer_ids && course.trainer_ids.length > 0) {
                return _(this.library.trainers).filter(i => _.includes(course.trainer_ids, i.id));
            }

            return [];
        },
        getOthersTrainers() {
            const course = _(this.library.courses).find({id: this.courseScheduleForm.course_id});
            if (course && course.trainer_ids && course.trainer_ids.length > 0) {
                return _(this.library.trainers).filter(i => !_.includes(course.trainer_ids, i.id));
            }

            return this.library.trainers;
        },

        updateTime(changed) {
            let from = dayjs(this.courseScheduleForm.time_from, 'HH:mm');
            let till = dayjs(this.courseScheduleForm.time_till, 'HH:mm');
            if (changed === 'from') {
                if (till.isBefore(from)) {
                    till = from.clone().add(1, 'hour');
                    this.courseScheduleForm.time_till = this.dateFormat(till, 'HH:mm');
                }
            }
            if (changed === 'till') {
                if (from.isAfter(till)) {
                    from = till.clone().subtract(1, 'hour');
                    this.courseScheduleForm.time_from = this.dateFormat(from, 'HH:mm');
                }
            }
        },

        hide() {
            this.modal.hide();
            this.$emit('closed');
        },

        checkForm: function (e) {
            let form = this.courseScheduleForm;
            let date = dayjs(form.date, 'YYYY-MM-DD');
            let from = dayjs(form.time_from, 'HH:mm');
            let till = dayjs(form.time_till, 'HH:mm');
            if (from.isAfter(till)) {
                this.errors.push('Time range is wrong');
            }
            if (date.isBefore(dayjs())) {
                this.errors.push('Date is past');
            }
            if (!form.course_id) {
                this.errors.push('Class is required');
            }
            if (!form.trainer_id) {
                this.errors.push('Trainer is required');
            }
            if (!form.course_level_id) {
                this.errors.push('Level is required');
            }
            if (!form.location_id) {
                this.errors.push('Location is required');
            }
            if (!form.reset_level_id) {
                this.errors.push('Path is required');
            }
            if (!form.capacity) {
                this.errors.push('Capacity is required');
            } else if (form.capacity < 1) {
                this.errors.push('Capacity must be at least 1');
            }
            if (this.errors.length === 0) {
                return true;
            }

            return false;
        },

        save() {
            if (this.checkForm()) {
                this.loading = true;
                this.$emit('created', {course_schedule: this.courseScheduleForm});
                this.viewType = null;
                this.courseSchedule = null;
                this.hide();
            }
        }


    },

    watch: {
        course_schedule(newVal, oldVal) {
            this.init();
        }
    },
    computed: {}
}
</script>
